import React, { useState } from 'react';
import { LIBRARY_VIDEO_DRAG_MIME } from './blockPaletteConstants';

/**
 * Makes an element a drop target for a video dragged out of the sidebar's
 * media tab. `over` is true while one is hovering it. `handleDrop` returns
 * whether it consumed the event, so a target that also accepts dropped files
 * can fall through to its own handling.
 */
export function useLibraryVideoDrop(onVideo: ((externalId: string) => void) | undefined) {
  const [over, setOver] = useState(false);
  const accepts = (event: React.DragEvent) =>
    !!onVideo && event.dataTransfer.types.includes(LIBRARY_VIDEO_DRAG_MIME);

  return {
    over,
    onDragOver: (event: React.DragEvent) => {
      if (!accepts(event)) return;
      event.preventDefault();
      event.dataTransfer.dropEffect = 'copy';
      setOver(true);
    },
    onDragLeave: (event: React.DragEvent) => {
      if (!event.currentTarget.contains(event.relatedTarget as Node | null)) setOver(false);
    },
    handleDrop: (event: React.DragEvent): boolean => {
      if (!accepts(event)) return false;
      event.preventDefault();
      setOver(false);
      const externalId = event.dataTransfer.getData(LIBRARY_VIDEO_DRAG_MIME);
      if (externalId) onVideo?.(externalId);
      return true;
    },
  };
}
